import React, { useState } from "react";
import { Modal, Alert, Button, Form } from "react-bootstrap";
import { FaCheck, FaTimes, FaUpload } from "react-icons/fa";
import { uploadImage, updatePracticeURL } from "../../api";

export function AddPracticeLogo({ practiceId, practiceLogoURL, show, onHide, onLogoUpdate }) {
  const [closeAlert, setCloseAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(
    practiceLogoURL ||
      "https://practostorage.blob.core.windows.net/practotest/logo-placeholder-image.png?sp=r&st=2025-02-14T06:32:12Z&se=2025-02-14T14:32:12Z&spr=https&sv=2022-11-02&sr=b&sig=MFFyJLok0cf0Gzy60IkhlmnFLo5ItUHBcI86lL%2F%2BU5I%3D"
  );

  const handleClose = () => {
    setCloseAlert(true);
  };

  const handleCancelNo = () => {
    setCloseAlert(false); // Hide alert and keep modal open
  };

  const handleCancelYes = async () => {
    setCloseAlert(false);
    onHide();
  };

  // Handle File Selection
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setSelectedFile(file);

      // Update preview with selected image
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle File Upload
  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file before submitting.");
      return;
    }

    const formData = new FormData();
    formData.append("image", selectedFile);
    formData.append("practiceId", practiceId);

    try {
      const response = await uploadImage(formData); // Replace with your actual API function
      setSuccessAlert(true);
      await updatePracticeURL(practiceId, response.imageUrl);
      onLogoUpdate();
      setTimeout(() => {
        setSuccessAlert(false);
        onHide();
      }, 2000);
    } catch (error) {
      alert("Image upload failed. Please try again.");
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header
        closeButton={!closeAlert && !successAlert}
        className="border-secondary"
      >
        <div className="w-100">
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-primary"
          >
            Edit Logo
            {closeAlert && (
              <Alert
                variant="info"
                className="w-100 d-flex align-items-center justify-content-between mt-3 fs-6 fw-normal"
              >
                <span>
                  Are you sure you want to close? The entered data will be
                  removed.
                </span>
                <div className="ms-auto d-flex">
                  <Button
                    variant="outline-primary"
                    className="btn btn-outline-primary me-1"
                    onClick={handleCancelYes}
                  >
                    <FaCheck />
                  </Button>
                  <Button
                    variant="outline-secondary"
                    className="btn btn-outline-secondary me-1"
                    onClick={handleCancelNo}
                  >
                    <FaTimes />
                  </Button>
                </div>
              </Alert>
            )}
            {successAlert && (
              <Alert
                variant="success"
                className="w-100 d-flex align-items-center justify-content-between mt-3 fs-6 fw-normal"
              >
                <span>The logo has been updated successfully</span>
              </Alert>
            )}
          </Modal.Title>
        </div>
      </Modal.Header>

      <Modal.Body className="text-center">
        {/* Logo Preview */}
        <div className="mb-3">
          <img
            src={previewImage}
            alt="Practice Logo"
            width={200}
            height={200}
            className="border"
            style={{ objectFit: "cover" }}
          />
        </div>

        {/* File Upload Input */}
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Upload New Logo</Form.Label>
          <Form.Control
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        </Form.Group>

        {/* Submit Button */}
        <Button variant="primary" onClick={handleUpload} className="mt-2">
          <FaUpload className="me-2" /> Submit New Logo
        </Button>
      </Modal.Body>
    </Modal>
  );
}
